import { CbhIcon, Text } from "@clipboard-health/ui-components";
import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export interface BoostedPayLabelProps {
  totalPayBeforeBoost: string | undefined;
  totalWithBoostPay: string;
  includePayBeforeBoost?: boolean;
  size?: "small" | "medium";
}

export function BoostedPayLabel(props: BoostedPayLabelProps) {
  const {
    totalPayBeforeBoost,
    totalWithBoostPay,
    includePayBeforeBoost = true,
    size = "medium",
  } = props;
  const theme = useTheme();

  return (
    <Stack direction="row" alignItems="center">
      {includePayBeforeBoost && isDefined(totalPayBeforeBoost) && (
        <Text
          variant={size === "small" ? "body2" : "body1"}
          sx={{
            textDecoration: "line-through",
            marginRight: 2,
            color: theme.palette.text.secondary,
          }}
        >
          {totalPayBeforeBoost}
        </Text>
      )}
      <CbhIcon
        type="bolt-filled"
        size="xSmall"
        sx={{ color: theme.palette.intent?.success.text }}
      />
      <Text
        variant={size === "small" ? "body2" : "body1"}
        sx={{ color: theme.palette.intent?.success.text }}
      >
        {totalWithBoostPay}
      </Text>
    </Stack>
  );
}
